import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import MainAnimation from "../../components/MainScreen/MainAnimation";
import ScoreBlock from "../../components/MainScreen/ScoreBlock";
import ScreenWrapper from "../../components/Wrappers/ScreenWrapper";
import {useAppSelector} from "../../hooks/hooks";
import Loader from "../../components/Loader";
import WebApp from "@twa-dev/sdk";
import TutorialSwipeBlock from "../../components/tutorial/TutorialSwipeBlock";
import ActionButton from "../../components/Buttons/ActionButton";
import router from "../../router/router";

const TutorialMainScreen: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const backgroundRef = React.useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);
    const swipeStateData = useAppSelector((state) => state.tutorial.swipes)
    const userData = useAppSelector((state) => state.user.data)

    useEffect(() => {
        WebApp.HapticFeedback.impactOccurred('soft');
        if(backgroundRef.current) {
            setHeight(backgroundRef.current.clientHeight / 2);
        }
    }, []);

    useEffect(() => {
        if (swipeStateData) {
            setLoading(false);
        }
    }, [swipeStateData]);

    const submitHandler = () => {
        router.navigate('/tutorial/codes');
    }

    const startHandler = () => {
        router.navigate('/');
    }

    return (
        <ScreenWrapper>
            <Loader loading={loading} duration={300}>
                <MainAnimation ref={backgroundRef} />
                <BodyWrapper>
                    <Body>
                        {!userData.has_checked_tutorial ?
                            <>
                                {swipeStateData.character_index === swipeStateData.characters.length ?
                                    <>
                                        <p style={{width: 'calc(100% - 52px)', margin: '0 auto 28px', lineHeight: '20px', fontSize: 16, fontWeight:700, color: '#F1D988'}}>Tutorial mode:<br/>Collect the required symbols to enter the code. Missed any? <br/><br/>Ask the community or check our social media for hints.</p>
                                        <div style={{display: "flex", justifyContent: "center"}}>
                                            <ActionButton width="calc(100% - 48px)" height="48px" type='active'
                                                          clickHandler={submitHandler}>crack the code!</ActionButton>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <TutorialSwipeBlock animationHeight={height}/>
                                        <ScoreBlock points={userData.points} day={swipeStateData.day} season={swipeStateData.season}/>
                                    </>
                                }
                            </>
                            :
                            <>
                                <h1 style={{fontSize:28, fontWeight:700, color: '#F1D988'}}>Tutorial is<br/> completed.</h1>
                                <p style={{fontSize:16, fontWeight:600, marginBottom: 32, color: '#F1D988'}}>Now you can start unlocking<br/> the secret.</p>
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <ActionButton width="calc(100% - 48px)" height="48px" type='active'
                                                  clickHandler={startHandler}>start</ActionButton>
                                </div>
                            </>
                        }

                    </Body>
                </BodyWrapper>
            </Loader>
        </ScreenWrapper>
    );
};

export default TutorialMainScreen;


const BodyWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    text-align: center;
`;
const Body = styled.div`
    width: 100%;
`;
